<template>
  <v-app>
    <v-app-bar :color="mainColor" class="lighten-3" app :dark="dark">
      <v-toolbar-title>Amtstafel {{ name }}</v-toolbar-title>
    </v-app-bar>
    <v-main style="padding-bottom: 150px">
      <Amtstafel :start-url="startUrl" :main-color="mainColor" :dark="dark" />
    </v-main>
      <v-sheet :color="mainColor" class="d-flex flex-column pa-3 lighten-3" style="position: fixed; left: 0px; bottom: 0px; width: 100%" :dark="dark">
        <v-container >
          <v-row>
            <v-col sm="4" cols="12" v-if="$vuetify.breakpoint.smAndUp">
              <v-btn block class="font-weight-bold rounded-lg mx-2 mb-2 body-1 py-6 px-3" outlined @click="startUrl=amtstafelUrl">Amtstafel</v-btn>
            </v-col>
            <v-col sm="4" cols="12">
              <v-btn block class="font-weight-bold rounded-lg mx-2 mb-2 body-1 py-6 px-3" outlined :href="geminfoUrl">Geminfo.app</v-btn>
            </v-col>
            <v-col sm="4" cols="12" v-if="$vuetify.breakpoint.smAndUp">
              <v-btn block class="font-weight-bold rounded-lg mx-2 mb-2 body-1 py-6 px-3" outlined :href="gemeindeUrl">{{ name }}</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
  </v-app>
</template>

<style lang="sass">
  .v-card__title
    word-break: break-word !important
    *
      word-break: break-word !important

</style>

<script>
import Amtstafel from './components/AmtstafelRiegersburg.vue';

export default {
  name: 'App',

  components: {
    Amtstafel,
  },
  mounted(){
    this.amtstafelUrl = this.startUrl
  },
  data: () => ({
    startUrl: "https://www.riegersburg.gv.at/aktuelles/amtstafel",
    gemeindeUrl: "https://www.riegersburg.gv.at/",
    geminfoUrl: "https://geminfo.app/riegersburg/",
    name: "Marktgemeinde Riegersburg",
    mainColor: "green darken-2",
    amtstafelUrl: null,
    dark: true,
  }),
};
</script>
